<template>
    <nav class="content">
        <router-link class="settingsItem"
            to="/settings">
            <div class="icon">
                <Icon
                    icon="settings"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.generalSettings }}</div>
                <p class="preference">{{ siteContent.languageCurrencyAppearanceMore }}</p>
            </div>
        </router-link>

        <router-link class="settingsItem"
            v-if="!auth.id"
            to="/auth">
            <div class="icon">
                <Icon
                    icon="account_circle"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.createAccount }}</div>
            </div>
        </router-link>

        <router-link class="settingsItem"
            to="/terms">
            <div class="icon">
                <Icon
                    icon="inbox"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.termsOfUse }}</div>
            </div>
        </router-link>

        <router-link class="settingsItem"
            to="/privacy">
            <div class="icon">
                <Icon
                    icon="security"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.privacy }}</div>
            </div>
        </router-link>

        <router-link class="settingsItem"
            to="/contact">
            <div class="icon">
                <Icon
                    icon="alternate_email"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.contact }}</div>
            </div>
        </router-link>

        <div class="settingsItem"
            v-if="auth.id"
            @click="logout"
            tabindex="0">
            <div class="icon">
                <Icon
                    icon="exit_to_app"
                    appearance="white"
                    size="m"/>
            </div>
            <div class="settingsContent">
                <div class="label">{{ siteContent.logout }}</div>
            </div>
        </div>
    </nav>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'SettingsList',
        methods: {
            ...mapActions('authentication',['logoutUser']),

            logout() {
                this.logoutUser()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 36rem;
        width: 100%;
        border-radius: 0.75rem;
        padding: 1rem;
        background: var(--color-grey-150);
        margin-bottom: 1rem;
    }

    .settingsItem {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 1rem;
        border-radius: 0.75rem;
        cursor: pointer;
        color: inherit;

        &:focus {
            box-shadow: var(--shadow-focus-s);
            outline: 0;
        }

        &:hover {
            .icon {
                background: var(--color-brand-500);
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
    
    .icon {
        padding: 0.5rem;
        background: var(--color-grey-200);
        transition: $transition-eio-20;
        border-radius: 1rem;
        margin-right: 1rem;
    }

    .label {
        font-family: $font-secondary;
        font-weight: 700;
        font-size: 1rem;
    }

    .preference {
        text-transform: uppercase;
        color: var(--color-grey-500);
        font-size: 0.75rem;
        margin: 0;
    }
</style>